// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VM6A0","fullView":"styles_fullView__1BL49"};